import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useImportContext } from '../import-context';
import { messages } from './messages';
import styles from './styles.module.less';
import { MappingTemplateRow } from './mapping-template-row';

export const MappingTemplatesTable = () => {
  const { mappingList } = useImportContext();

  return (
    <table className={styles['import-template-table']}>
      <thead>
        <tr>
          <th key='name' className={styles['provider-name-cell']}>
            <FormattedMessage {...messages.templatesTableNameHeader} />
          </th>
          <th key='actions' className={styles['actions-cell']}>
            <FormattedMessage {...messages.templatesTableActionsHeader} />
          </th>
        </tr>
      </thead>
      <tbody>
        {mappingList.map((mapping) => {
          return <MappingTemplateRow key={mapping.mappingId} importTemplate={mapping} />;
        })}
      </tbody>
    </table>
  );
};
